export default __webpack_public_path__ + "static/N0042-129e0c347e1f8e853792d19a6529e26d.png";